module.exports = "/_next/static/images/projectEngineering3-dfe4441fe96559436acb976df240da52.webp";